
let wasm;

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}
/**
* @returns {GatesHandle}
*/
export function get_gates_handle() {
    var ret = wasm.get_gates_handle();
    return GatesHandle.__wrap(ret);
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachegetInt32Memory0 = null;
function getInt32Memory0() {
    if (cachegetInt32Memory0 === null || cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
        cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachegetInt32Memory0;
}

function getArrayU8FromWasm0(ptr, len) {
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}

let WASM_VECTOR_LEN = 0;

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1);
    getUint8Memory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
* @returns {PCBHandle}
*/
export function get_pcb_handle() {
    var ret = wasm.get_pcb_handle();
    return PCBHandle.__wrap(ret);
}

/**
* @returns {LatchHandle}
*/
export function get_latch_handle() {
    var ret = wasm.get_latch_handle();
    return LatchHandle.__wrap(ret);
}

/**
* @returns {RippleAdderHandle}
*/
export function get_ripple_adder_handle() {
    var ret = wasm.get_ripple_adder_handle();
    return RippleAdderHandle.__wrap(ret);
}

/**
* @returns {CLAAdderHandle}
*/
export function get_cla_adder_handle() {
    var ret = wasm.get_cla_adder_handle();
    return CLAAdderHandle.__wrap(ret);
}

/**
* @returns {CounterHandle}
*/
export function get_counter_handle() {
    var ret = wasm.get_counter_handle();
    return CounterHandle.__wrap(ret);
}

/**
*/
export class CLAAdderBinding {

    static __wrap(ptr) {
        const obj = Object.create(CLAAdderBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_claadderbinding_free(ptr);
    }
    /**
    */
    get a0() {
        var ret = wasm.__wbg_get_claadderbinding_a0(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a0(arg0) {
        wasm.__wbg_set_claadderbinding_a0(this.ptr, arg0);
    }
    /**
    */
    get a1() {
        var ret = wasm.__wbg_get_claadderbinding_a1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a1(arg0) {
        wasm.__wbg_set_claadderbinding_a1(this.ptr, arg0);
    }
    /**
    */
    get a2() {
        var ret = wasm.__wbg_get_claadderbinding_a2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a2(arg0) {
        wasm.__wbg_set_claadderbinding_a2(this.ptr, arg0);
    }
    /**
    */
    get a3() {
        var ret = wasm.__wbg_get_claadderbinding_a3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a3(arg0) {
        wasm.__wbg_set_claadderbinding_a3(this.ptr, arg0);
    }
    /**
    */
    get b0() {
        var ret = wasm.__wbg_get_claadderbinding_b0(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b0(arg0) {
        wasm.__wbg_set_claadderbinding_b0(this.ptr, arg0);
    }
    /**
    */
    get b1() {
        var ret = wasm.__wbg_get_claadderbinding_b1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b1(arg0) {
        wasm.__wbg_set_claadderbinding_b1(this.ptr, arg0);
    }
    /**
    */
    get b2() {
        var ret = wasm.__wbg_get_claadderbinding_b2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b2(arg0) {
        wasm.__wbg_set_claadderbinding_b2(this.ptr, arg0);
    }
    /**
    */
    get b3() {
        var ret = wasm.__wbg_get_claadderbinding_b3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b3(arg0) {
        wasm.__wbg_set_claadderbinding_b3(this.ptr, arg0);
    }
    /**
    */
    get cin() {
        var ret = wasm.__wbg_get_claadderbinding_cin(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set cin(arg0) {
        wasm.__wbg_set_claadderbinding_cin(this.ptr, arg0);
    }
    /**
    */
    get s0() {
        var ret = wasm.__wbg_get_claadderbinding_s0(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s0(arg0) {
        wasm.__wbg_set_claadderbinding_s0(this.ptr, arg0);
    }
    /**
    */
    get s1() {
        var ret = wasm.__wbg_get_claadderbinding_s1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s1(arg0) {
        wasm.__wbg_set_claadderbinding_s1(this.ptr, arg0);
    }
    /**
    */
    get s2() {
        var ret = wasm.__wbg_get_claadderbinding_s2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s2(arg0) {
        wasm.__wbg_set_claadderbinding_s2(this.ptr, arg0);
    }
    /**
    */
    get s3() {
        var ret = wasm.__wbg_get_claadderbinding_s3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s3(arg0) {
        wasm.__wbg_set_claadderbinding_s3(this.ptr, arg0);
    }
    /**
    */
    get carry() {
        var ret = wasm.__wbg_get_claadderbinding_carry(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set carry(arg0) {
        wasm.__wbg_set_claadderbinding_carry(this.ptr, arg0);
    }
    /**
    * @returns {CLAAdderBinding}
    */
    static new() {
        var ret = wasm.claadderbinding_new();
        return CLAAdderBinding.__wrap(ret);
    }
}
/**
*/
export class CLAAdderHandle {

    static __wrap(ptr) {
        const obj = Object.create(CLAAdderHandle.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_claadderhandle_free(ptr);
    }
    /**
    * @param {CLAAdderBinding} bindings
    * @returns {CLAAdderBinding}
    */
    tick(bindings) {
        _assertClass(bindings, CLAAdderBinding);
        var ptr0 = bindings.ptr;
        bindings.ptr = 0;
        var ret = wasm.claadderhandle_tick(this.ptr, ptr0);
        return CLAAdderBinding.__wrap(ret);
    }
}
/**
*/
export class CPUStateData {

    static __wrap(ptr) {
        const obj = Object.create(CPUStateData.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cpustatedata_free(ptr);
    }
    /**
    */
    get addr() {
        var ret = wasm.__wbg_get_cpustatedata_addr(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set addr(arg0) {
        wasm.__wbg_set_cpustatedata_addr(this.ptr, arg0);
    }
    /**
    */
    get data() {
        var ret = wasm.__wbg_get_cpustatedata_data(this.ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
    * @param {number | undefined} arg0
    */
    set data(arg0) {
        wasm.__wbg_set_cpustatedata_data(this.ptr, isLikeNone(arg0) ? 0xFFFFFF : arg0);
    }
    /**
    */
    get mem_active() {
        var ret = wasm.__wbg_get_cpustatedata_mem_active(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set mem_active(arg0) {
        wasm.__wbg_set_cpustatedata_mem_active(this.ptr, arg0);
    }
    /**
    */
    get read_mem() {
        var ret = wasm.__wbg_get_cpustatedata_read_mem(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set read_mem(arg0) {
        wasm.__wbg_set_cpustatedata_read_mem(this.ptr, arg0);
    }
    /**
    */
    get io_latch() {
        var ret = wasm.__wbg_get_cpustatedata_io_latch(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set io_latch(arg0) {
        wasm.__wbg_set_cpustatedata_io_latch(this.ptr, arg0);
    }
    /**
    */
    get instr_ptr() {
        var ret = wasm.__wbg_get_cpustatedata_instr_ptr(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set instr_ptr(arg0) {
        wasm.__wbg_set_cpustatedata_instr_ptr(this.ptr, arg0);
    }
    /**
    */
    get reg1() {
        var ret = wasm.__wbg_get_cpustatedata_reg1(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set reg1(arg0) {
        wasm.__wbg_set_cpustatedata_reg1(this.ptr, arg0);
    }
    /**
    */
    get reg2() {
        var ret = wasm.__wbg_get_cpustatedata_reg2(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set reg2(arg0) {
        wasm.__wbg_set_cpustatedata_reg2(this.ptr, arg0);
    }
    /**
    */
    get zero() {
        var ret = wasm.__wbg_get_cpustatedata_zero(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set zero(arg0) {
        wasm.__wbg_set_cpustatedata_zero(this.ptr, arg0);
    }
    /**
    */
    get gt() {
        var ret = wasm.__wbg_get_cpustatedata_gt(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set gt(arg0) {
        wasm.__wbg_set_cpustatedata_gt(this.ptr, arg0);
    }
    /**
    */
    get lt() {
        var ret = wasm.__wbg_get_cpustatedata_lt(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set lt(arg0) {
        wasm.__wbg_set_cpustatedata_lt(this.ptr, arg0);
    }
}
/**
*/
export class CounterBinding {

    static __wrap(ptr) {
        const obj = Object.create(CounterBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_counterbinding_free(ptr);
    }
    /**
    */
    get e() {
        var ret = wasm.__wbg_get_counterbinding_e(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set e(arg0) {
        wasm.__wbg_set_counterbinding_e(this.ptr, arg0);
    }
    /**
    */
    get r() {
        var ret = wasm.__wbg_get_counterbinding_r(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set r(arg0) {
        wasm.__wbg_set_counterbinding_r(this.ptr, arg0);
    }
    /**
    * @returns {CounterBinding}
    */
    static new() {
        var ret = wasm.counterbinding_new();
        return CounterBinding.__wrap(ret);
    }
}
/**
*/
export class CounterHandle {

    static __wrap(ptr) {
        const obj = Object.create(CounterHandle.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_counterhandle_free(ptr);
    }
    /**
    * @param {CounterBinding} b
    * @returns {CounterValueBinding}
    */
    tick_one_hot(b) {
        _assertClass(b, CounterBinding);
        var ptr0 = b.ptr;
        b.ptr = 0;
        var ret = wasm.counterhandle_tick_one_hot(this.ptr, ptr0);
        return CounterValueBinding.__wrap(ret);
    }
    /**
    * @param {CounterBinding} b
    * @returns {CounterValueBinding}
    */
    tick_johnson_ring(b) {
        _assertClass(b, CounterBinding);
        var ptr0 = b.ptr;
        b.ptr = 0;
        var ret = wasm.counterhandle_tick_johnson_ring(this.ptr, ptr0);
        return CounterValueBinding.__wrap(ret);
    }
}
/**
*/
export class CounterValueBinding {

    static __wrap(ptr) {
        const obj = Object.create(CounterValueBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_countervaluebinding_free(ptr);
    }
    /**
    */
    get q1() {
        var ret = wasm.__wbg_get_countervaluebinding_q1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set q1(arg0) {
        wasm.__wbg_set_countervaluebinding_q1(this.ptr, arg0);
    }
    /**
    */
    get q2() {
        var ret = wasm.__wbg_get_countervaluebinding_q2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set q2(arg0) {
        wasm.__wbg_set_countervaluebinding_q2(this.ptr, arg0);
    }
    /**
    */
    get q3() {
        var ret = wasm.__wbg_get_countervaluebinding_q3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set q3(arg0) {
        wasm.__wbg_set_countervaluebinding_q3(this.ptr, arg0);
    }
    /**
    */
    get q4() {
        var ret = wasm.__wbg_get_countervaluebinding_q4(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set q4(arg0) {
        wasm.__wbg_set_countervaluebinding_q4(this.ptr, arg0);
    }
}
/**
*/
export class DBinding {

    static __wrap(ptr) {
        const obj = Object.create(DBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_dbinding_free(ptr);
    }
    /**
    */
    get d() {
        var ret = wasm.__wbg_get_dbinding_d(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set d(arg0) {
        wasm.__wbg_set_dbinding_d(this.ptr, arg0);
    }
    /**
    */
    get e() {
        var ret = wasm.__wbg_get_dbinding_e(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set e(arg0) {
        wasm.__wbg_set_dbinding_e(this.ptr, arg0);
    }
    /**
    * @returns {DBinding}
    */
    static new() {
        var ret = wasm.dbinding_new();
        return DBinding.__wrap(ret);
    }
}
/**
*/
export class GatedSRBinding {

    static __wrap(ptr) {
        const obj = Object.create(GatedSRBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gatedsrbinding_free(ptr);
    }
    /**
    */
    get s() {
        var ret = wasm.__wbg_get_gatedsrbinding_s(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s(arg0) {
        wasm.__wbg_set_gatedsrbinding_s(this.ptr, arg0);
    }
    /**
    */
    get r() {
        var ret = wasm.__wbg_get_gatedsrbinding_r(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set r(arg0) {
        wasm.__wbg_set_gatedsrbinding_r(this.ptr, arg0);
    }
    /**
    */
    get e() {
        var ret = wasm.__wbg_get_gatedsrbinding_e(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set e(arg0) {
        wasm.__wbg_set_gatedsrbinding_e(this.ptr, arg0);
    }
    /**
    * @returns {GatedSRBinding}
    */
    static new() {
        var ret = wasm.gatedsrbinding_new();
        return GatedSRBinding.__wrap(ret);
    }
}
/**
*/
export class GatesBinding {

    static __wrap(ptr) {
        const obj = Object.create(GatesBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gatesbinding_free(ptr);
    }
    /**
    */
    get not_in() {
        var ret = wasm.__wbg_get_gatesbinding_not_in(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set not_in(arg0) {
        wasm.__wbg_set_gatesbinding_not_in(this.ptr, arg0);
    }
    /**
    */
    get not_out() {
        var ret = wasm.__wbg_get_gatesbinding_not_out(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set not_out(arg0) {
        wasm.__wbg_set_gatesbinding_not_out(this.ptr, arg0);
    }
    /**
    */
    get and_in1() {
        var ret = wasm.__wbg_get_gatesbinding_and_in1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set and_in1(arg0) {
        wasm.__wbg_set_gatesbinding_and_in1(this.ptr, arg0);
    }
    /**
    */
    get and_in2() {
        var ret = wasm.__wbg_get_gatesbinding_and_in2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set and_in2(arg0) {
        wasm.__wbg_set_gatesbinding_and_in2(this.ptr, arg0);
    }
    /**
    */
    get and_out() {
        var ret = wasm.__wbg_get_gatesbinding_and_out(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set and_out(arg0) {
        wasm.__wbg_set_gatesbinding_and_out(this.ptr, arg0);
    }
    /**
    */
    get or_in1() {
        var ret = wasm.__wbg_get_gatesbinding_or_in1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set or_in1(arg0) {
        wasm.__wbg_set_gatesbinding_or_in1(this.ptr, arg0);
    }
    /**
    */
    get or_in2() {
        var ret = wasm.__wbg_get_gatesbinding_or_in2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set or_in2(arg0) {
        wasm.__wbg_set_gatesbinding_or_in2(this.ptr, arg0);
    }
    /**
    */
    get or_out() {
        var ret = wasm.__wbg_get_gatesbinding_or_out(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set or_out(arg0) {
        wasm.__wbg_set_gatesbinding_or_out(this.ptr, arg0);
    }
    /**
    */
    get xor_in1() {
        var ret = wasm.__wbg_get_gatesbinding_xor_in1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set xor_in1(arg0) {
        wasm.__wbg_set_gatesbinding_xor_in1(this.ptr, arg0);
    }
    /**
    */
    get xor_in2() {
        var ret = wasm.__wbg_get_gatesbinding_xor_in2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set xor_in2(arg0) {
        wasm.__wbg_set_gatesbinding_xor_in2(this.ptr, arg0);
    }
    /**
    */
    get xor_out() {
        var ret = wasm.__wbg_get_gatesbinding_xor_out(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set xor_out(arg0) {
        wasm.__wbg_set_gatesbinding_xor_out(this.ptr, arg0);
    }
    /**
    * @returns {GatesBinding}
    */
    static new() {
        var ret = wasm.gatesbinding_new();
        return GatesBinding.__wrap(ret);
    }
}
/**
*/
export class GatesHandle {

    static __wrap(ptr) {
        const obj = Object.create(GatesHandle.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_gateshandle_free(ptr);
    }
    /**
    * @param {GatesBinding} binding
    * @returns {GatesBinding}
    */
    tick(binding) {
        _assertClass(binding, GatesBinding);
        var ptr0 = binding.ptr;
        binding.ptr = 0;
        var ret = wasm.gateshandle_tick(this.ptr, ptr0);
        return GatesBinding.__wrap(ret);
    }
}
/**
*/
export class JKBinding {

    static __wrap(ptr) {
        const obj = Object.create(JKBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_jkbinding_free(ptr);
    }
    /**
    */
    get j() {
        var ret = wasm.__wbg_get_jkbinding_j(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set j(arg0) {
        wasm.__wbg_set_jkbinding_j(this.ptr, arg0);
    }
    /**
    */
    get k() {
        var ret = wasm.__wbg_get_jkbinding_k(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set k(arg0) {
        wasm.__wbg_set_jkbinding_k(this.ptr, arg0);
    }
    /**
    */
    get e() {
        var ret = wasm.__wbg_get_jkbinding_e(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set e(arg0) {
        wasm.__wbg_set_jkbinding_e(this.ptr, arg0);
    }
    /**
    * @returns {JKBinding}
    */
    static new() {
        var ret = wasm.jkbinding_new();
        return JKBinding.__wrap(ret);
    }
}
/**
*/
export class LatchHandle {

    static __wrap(ptr) {
        const obj = Object.create(LatchHandle.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_latchhandle_free(ptr);
    }
    /**
    * @param {SRBinding} data
    * @returns {LatchOut}
    */
    tick_sr(data) {
        _assertClass(data, SRBinding);
        var ptr0 = data.ptr;
        data.ptr = 0;
        var ret = wasm.latchhandle_tick_sr(this.ptr, ptr0);
        return LatchOut.__wrap(ret);
    }
    /**
    * @param {GatedSRBinding} data
    * @returns {LatchOut}
    */
    tick_gated_sr(data) {
        _assertClass(data, GatedSRBinding);
        var ptr0 = data.ptr;
        data.ptr = 0;
        var ret = wasm.latchhandle_tick_gated_sr(this.ptr, ptr0);
        return LatchOut.__wrap(ret);
    }
    /**
    * @param {DBinding} data
    * @returns {LatchOut}
    */
    tick_dlatch(data) {
        _assertClass(data, DBinding);
        var ptr0 = data.ptr;
        data.ptr = 0;
        var ret = wasm.latchhandle_tick_dlatch(this.ptr, ptr0);
        return LatchOut.__wrap(ret);
    }
    /**
    * @param {TBinding} data
    * @returns {LatchOut}
    */
    tick_tlatch(data) {
        _assertClass(data, TBinding);
        var ptr0 = data.ptr;
        data.ptr = 0;
        var ret = wasm.latchhandle_tick_tlatch(this.ptr, ptr0);
        return LatchOut.__wrap(ret);
    }
    /**
    * @param {JKBinding} data
    * @returns {LatchOut}
    */
    tick_jk(data) {
        _assertClass(data, JKBinding);
        var ptr0 = data.ptr;
        data.ptr = 0;
        var ret = wasm.latchhandle_tick_jk(this.ptr, ptr0);
        return LatchOut.__wrap(ret);
    }
}
/**
*/
export class LatchOut {

    static __wrap(ptr) {
        const obj = Object.create(LatchOut.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_latchout_free(ptr);
    }
    /**
    */
    get q() {
        var ret = wasm.__wbg_get_latchout_q(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set q(arg0) {
        wasm.__wbg_set_latchout_q(this.ptr, arg0);
    }
    /**
    */
    get notq() {
        var ret = wasm.__wbg_get_latchout_notq(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set notq(arg0) {
        wasm.__wbg_set_latchout_notq(this.ptr, arg0);
    }
}
/**
*/
export class PCBHandle {

    static __wrap(ptr) {
        const obj = Object.create(PCBHandle.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_pcbhandle_free(ptr);
    }
    /**
    * @returns {Uint8Array}
    */
    get_cpu_instr_cache() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pcbhandle_get_cpu_instr_cache(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v0 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1);
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get_cpu_state() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pcbhandle_get_cpu_state(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(r0, r1);
        }
    }
    /**
    * @returns {CPUStateData}
    */
    get_cpu_reg_flags() {
        var ret = wasm.pcbhandle_get_cpu_reg_flags(this.ptr);
        return CPUStateData.__wrap(ret);
    }
    /**
    * @returns {RAMStateData}
    */
    get_ram_state() {
        var ret = wasm.pcbhandle_get_ram_state(this.ptr);
        return RAMStateData.__wrap(ret);
    }
    /**
    * @returns {Uint8Array}
    */
    get_mem_array() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pcbhandle_get_mem_array(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v0 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1);
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    */
    tick() {
        wasm.pcbhandle_tick(this.ptr);
    }
    /**
    * @param {Uint8Array} asm
    */
    load(asm) {
        var ptr0 = passArray8ToWasm0(asm, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.pcbhandle_load(this.ptr, ptr0, len0);
    }
}
/**
*/
export class RAMStateData {

    static __wrap(ptr) {
        const obj = Object.create(RAMStateData.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ramstatedata_free(ptr);
    }
    /**
    */
    get addr() {
        var ret = wasm.__wbg_get_ramstatedata_addr(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set addr(arg0) {
        wasm.__wbg_set_ramstatedata_addr(this.ptr, arg0);
    }
    /**
    */
    get data() {
        var ret = wasm.__wbg_get_ramstatedata_data(this.ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
    * @param {number | undefined} arg0
    */
    set data(arg0) {
        wasm.__wbg_set_ramstatedata_data(this.ptr, isLikeNone(arg0) ? 0xFFFFFF : arg0);
    }
    /**
    */
    get is_active() {
        var ret = wasm.__wbg_get_ramstatedata_is_active(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_active(arg0) {
        wasm.__wbg_set_ramstatedata_is_active(this.ptr, arg0);
    }
    /**
    */
    get is_read() {
        var ret = wasm.__wbg_get_ramstatedata_is_read(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_read(arg0) {
        wasm.__wbg_set_ramstatedata_is_read(this.ptr, arg0);
    }
    /**
    */
    get io_latch() {
        var ret = wasm.__wbg_get_ramstatedata_io_latch(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set io_latch(arg0) {
        wasm.__wbg_set_ramstatedata_io_latch(this.ptr, arg0);
    }
}
/**
*/
export class RippleAdderBinding {

    static __wrap(ptr) {
        const obj = Object.create(RippleAdderBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rippleadderbinding_free(ptr);
    }
    /**
    */
    get a0() {
        var ret = wasm.__wbg_get_rippleadderbinding_a0(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a0(arg0) {
        wasm.__wbg_set_rippleadderbinding_a0(this.ptr, arg0);
    }
    /**
    */
    get a1() {
        var ret = wasm.__wbg_get_rippleadderbinding_a1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a1(arg0) {
        wasm.__wbg_set_rippleadderbinding_a1(this.ptr, arg0);
    }
    /**
    */
    get a2() {
        var ret = wasm.__wbg_get_rippleadderbinding_a2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a2(arg0) {
        wasm.__wbg_set_rippleadderbinding_a2(this.ptr, arg0);
    }
    /**
    */
    get a3() {
        var ret = wasm.__wbg_get_rippleadderbinding_a3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set a3(arg0) {
        wasm.__wbg_set_rippleadderbinding_a3(this.ptr, arg0);
    }
    /**
    */
    get b0() {
        var ret = wasm.__wbg_get_rippleadderbinding_b0(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b0(arg0) {
        wasm.__wbg_set_rippleadderbinding_b0(this.ptr, arg0);
    }
    /**
    */
    get b1() {
        var ret = wasm.__wbg_get_rippleadderbinding_b1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b1(arg0) {
        wasm.__wbg_set_rippleadderbinding_b1(this.ptr, arg0);
    }
    /**
    */
    get b2() {
        var ret = wasm.__wbg_get_rippleadderbinding_b2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b2(arg0) {
        wasm.__wbg_set_rippleadderbinding_b2(this.ptr, arg0);
    }
    /**
    */
    get b3() {
        var ret = wasm.__wbg_get_rippleadderbinding_b3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set b3(arg0) {
        wasm.__wbg_set_rippleadderbinding_b3(this.ptr, arg0);
    }
    /**
    */
    get cin() {
        var ret = wasm.__wbg_get_rippleadderbinding_cin(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set cin(arg0) {
        wasm.__wbg_set_rippleadderbinding_cin(this.ptr, arg0);
    }
    /**
    */
    get s0() {
        var ret = wasm.__wbg_get_rippleadderbinding_s0(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s0(arg0) {
        wasm.__wbg_set_rippleadderbinding_s0(this.ptr, arg0);
    }
    /**
    */
    get s1() {
        var ret = wasm.__wbg_get_rippleadderbinding_s1(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s1(arg0) {
        wasm.__wbg_set_rippleadderbinding_s1(this.ptr, arg0);
    }
    /**
    */
    get s2() {
        var ret = wasm.__wbg_get_rippleadderbinding_s2(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s2(arg0) {
        wasm.__wbg_set_rippleadderbinding_s2(this.ptr, arg0);
    }
    /**
    */
    get s3() {
        var ret = wasm.__wbg_get_rippleadderbinding_s3(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s3(arg0) {
        wasm.__wbg_set_rippleadderbinding_s3(this.ptr, arg0);
    }
    /**
    */
    get carry() {
        var ret = wasm.__wbg_get_rippleadderbinding_carry(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set carry(arg0) {
        wasm.__wbg_set_rippleadderbinding_carry(this.ptr, arg0);
    }
    /**
    * @returns {RippleAdderBinding}
    */
    static new() {
        var ret = wasm.rippleadderbinding_new();
        return RippleAdderBinding.__wrap(ret);
    }
}
/**
*/
export class RippleAdderHandle {

    static __wrap(ptr) {
        const obj = Object.create(RippleAdderHandle.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_rippleadderhandle_free(ptr);
    }
    /**
    * @param {RippleAdderBinding} bindings
    * @returns {RippleAdderBinding}
    */
    tick(bindings) {
        _assertClass(bindings, RippleAdderBinding);
        var ptr0 = bindings.ptr;
        bindings.ptr = 0;
        var ret = wasm.rippleadderhandle_tick(this.ptr, ptr0);
        return RippleAdderBinding.__wrap(ret);
    }
}
/**
*/
export class SRBinding {

    static __wrap(ptr) {
        const obj = Object.create(SRBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_srbinding_free(ptr);
    }
    /**
    */
    get s() {
        var ret = wasm.__wbg_get_srbinding_s(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set s(arg0) {
        wasm.__wbg_set_srbinding_s(this.ptr, arg0);
    }
    /**
    */
    get r() {
        var ret = wasm.__wbg_get_srbinding_r(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set r(arg0) {
        wasm.__wbg_set_srbinding_r(this.ptr, arg0);
    }
    /**
    * @returns {SRBinding}
    */
    static new() {
        var ret = wasm.srbinding_new();
        return SRBinding.__wrap(ret);
    }
}
/**
*/
export class TBinding {

    static __wrap(ptr) {
        const obj = Object.create(TBinding.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tbinding_free(ptr);
    }
    /**
    */
    get t() {
        var ret = wasm.__wbg_get_tbinding_t(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set t(arg0) {
        wasm.__wbg_set_tbinding_t(this.ptr, arg0);
    }
    /**
    */
    get e() {
        var ret = wasm.__wbg_get_tbinding_e(this.ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set e(arg0) {
        wasm.__wbg_set_tbinding_e(this.ptr, arg0);
    }
    /**
    * @returns {TBinding}
    */
    static new() {
        var ret = wasm.tbinding_new();
        return TBinding.__wrap(ret);
    }
}

async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

async function init(input) {
    if (typeof input === 'undefined') {
        input = new URL('index_bg.wasm', import.meta.url);
    }
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }



    const { instance, module } = await load(await input, imports);

    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;

    return wasm;
}

export default init;

